import {ensure} from "../lib/picos/ensure";
import ArrayMap from "../lib/ArrayMap";

import AccountingConnection from "./accountingConnection";
import ActivityCategory from "./activityCategory";
import ActivityType from "./activityType";
import Address from "./address";
import Answer from "./answer";
import BankAccount from "./bankAccount";
import Blackout from "./blackout";
import Category from "./category";
import Campaign from "./campaign";
import Docket from "./docket";
import Matter from "./matter";
import Comment from "./comment";
import CaseType from "./caseType";
import CaseTypeStage from "./caseTypeStage";
import Deadline from "./deadline";
import DeadlineRule from "./deadlineRule";
import Conflict from "./conflict";
import Contact from "./contact";
import Court from "./court";
import CourtDeadlineRule from "./courtDeadlineRule";
import Discount from "./discount";
import EntityTimestamp from "./entityTimestamp";
import Document from "./document";
import Expense from "./expense";
import Event from "./event";
import Firm from "./firm";
import FlatFee from "./flatFee";
import FlatFeeMilestone from "./flatFeeMilestone";
import Group from "./group";
import HolidayCalendar from "./holidayCalendar";
import Identification from "./identification";
import ImportExport from "./importExport";
import ImportSource from "./importSource";
import Invoice from "./invoice";
import InvoiceBatch from "./invoiceBatch";
import InvoiceBatchItem from "./invoiceBatchItem";
import Lawpay from "./lawpay";
import Lead from "./lead";
import Lookup from "./lookup";
import MatterStage from "./matterStage";
import Milestone from "./milestone";
import Option from "./option";
import Participant from "./participant";
import Privilege from "./privilege";
import Question from "./question";
import RedFlagType from "./redFlagType";
import RedFlag from "./redFlag";
import Resource from "./resource";
import Referral from "./referral";
import Role from "./role";
import Task from "./task";
import TemplateTask from "./templateTask";
import TimeOff from "./timeOff";
import Transaction from "./transaction";
import User from "./user";

const initialState = {
	accountingConnections: new ArrayMap<AccountingConnection>('AccountingConnection'),
	activityCategories: new ArrayMap<ActivityCategory>('ActivityCategory'),
	activityTypes: new ArrayMap<ActivityType>('ActivityType'),
	addresses: new ArrayMap<Address>('Address'),
	answers: new ArrayMap<Answer>('Answer'),
	bankAccounts: new ArrayMap<BankAccount>('BankAccount'),
	blackouts: new ArrayMap<Blackout>('Blackout'),
	campaigns: new ArrayMap<Campaign>('Campaign'),
	caseTypeStages: new ArrayMap<CaseTypeStage>('CaseTypeStage'),
	caseTypes: new ArrayMap<CaseType>('CaseType'),
	categories: new ArrayMap<Category>('Category'),
	comments: new ArrayMap<Comment>('Comment'),
	conflicts: new ArrayMap<Conflict>('Conflict'),
	contacts: new ArrayMap<Contact>('Contact'),
	courtDeadlineRules: new ArrayMap<CourtDeadlineRule>('CourtDeadlineRule'),
	courts: new ArrayMap<Court>('Court'),
	deadlineRules: new ArrayMap<DeadlineRule>('DeadlineRule'),
	deadlines: new ArrayMap<Deadline>('Deadline'),
	discounts: new ArrayMap<Discount>('Discount'),
	dockets: new ArrayMap<Docket>('Docket'),
	documents: new ArrayMap<Document>('Document'),
	entityTimestamps: new ArrayMap<EntityTimestamp>('EntityTimestamp'),
	events: new ArrayMap<Event>('Event'),
	expenses: new ArrayMap<Expense>('Expense'),
	firms: new ArrayMap<Firm>('Firm'),
	flatFeeMilestones: new ArrayMap<FlatFeeMilestone>('FlatFeeMilestone'),
	flatFees: new ArrayMap<FlatFee>('FlatFee'),
	groups: new ArrayMap<Group>('Group'),
	holidayCalendars: new ArrayMap<HolidayCalendar>('HolidayCalendar'),
	identifications: new ArrayMap<Identification>('Identification'),
	importExports: new ArrayMap<ImportExport>('ImportExport'),
	importSources: new ArrayMap<ImportSource>('ImportSource'),
	invoiceBatchItems: new ArrayMap<InvoiceBatchItem>('InvoiceBatchItem'),
	invoiceBatches: new ArrayMap<InvoiceBatch>('InvoiceBatch'),
	invoices: new ArrayMap<Invoice>('Invoice'),
	leads: new ArrayMap<Lead>('Lead'),
	lookups: new ArrayMap<Lookup>('Lookup'),
	matterStages: new ArrayMap<MatterStage>('MatterStage'),
	matters: new ArrayMap<Matter>('Matter'),
	milestones: new ArrayMap<Milestone>('Milestone'),
	options: new ArrayMap<Option>('Option'),
	participants: new ArrayMap<Participant>('Participant'),
	privileges: new ArrayMap<Privilege>('Privilege'),
	questions: new ArrayMap<Question>('Question'),
	redFlagTypes: new ArrayMap<RedFlagType>('RedFlagType'),
	redFlags: new ArrayMap<RedFlag>('RedFlag'),
	referrals: new ArrayMap<Referral>('Referral'),
	resources: new ArrayMap<Resource>('Resource'),
	roles: new ArrayMap<Role>('Role'),
	tasks: new ArrayMap<Task>('Task'),
	templateTasks: new ArrayMap<TemplateTask>('TemplateTask'),
	timeOffs: new ArrayMap<TimeOff>('TimeOff'),
	transactions: new ArrayMap<Transaction>('Transaction'),
	users: new ArrayMap<User>('User')
}

function cast<T>(entity: string, value: any): T {
	switch(entity) {
		case 'accountingConnection':
			return ensure(AccountingConnection, value) as T;
		case 'activityCategory':
			return ensure(ActivityCategory, value) as T;
		case 'activityType':
			return ensure(ActivityType, value) as T;
		case 'address':
			return ensure(Address, value) as T;
		case 'answer':
			return ensure(Answer, value) as T;
		case 'bankAccount':
			return ensure(BankAccount, value) as T;
		case 'blackout':
			return ensure(Blackout, value) as T;
		case 'category':
			return ensure(Category, value) as T;
		case 'campaign':
			return ensure(Campaign, value) as T;
		case 'docket':
			return ensure(Docket, value) as T;
		case 'matter':
			return ensure(Matter, value) as T;
		case 'comment':
			return ensure(Comment, value) as T;
		case 'caseType':
			return ensure(CaseType, value) as T;
		case 'caseTypeStage':
			return ensure(CaseTypeStage, value) as T;
		case 'deadline':
			return ensure(Deadline, value) as T;
		case 'deadlineRule':
			return ensure(DeadlineRule, value) as T;
		case 'conflict':
			return ensure(Conflict, value) as T;
		case 'contact':
			return ensure(Contact, value) as T;
		case 'court':
			return ensure(Court, value) as T;
		case 'courtDeadlineRule':
			return ensure(CourtDeadlineRule, value) as T;
		case 'discount':
			return ensure(Discount, value) as T;
		case 'entityTimestamp':
			return ensure(EntityTimestamp, value) as T;
		case 'document':
			return ensure(Document, value) as T;
		case 'expense':
			return ensure(Expense, value) as T;
		case 'event':
			return ensure(Event, value) as T;
		case 'firm':
			return ensure(Firm, value) as T;
		case 'flatFee':
			return ensure(FlatFee, value) as T;
		case 'flatFeeMilestone':
			return ensure(FlatFeeMilestone, value) as T;
		case 'group':
			return ensure(Group, value) as T;
		case 'holidayCalendar':
			return ensure(HolidayCalendar, value) as T;
		case 'identification':
			return ensure(Identification, value) as T;
		case 'importExport':
			return ensure(ImportExport, value) as T;
		case 'importSource':
			return ensure(ImportSource, value) as T;
		case 'invoice':
			return ensure(Invoice, value) as T;
		case 'invoiceBatch':
			return ensure(InvoiceBatch, value) as T;
		case 'invoiceBatchItem':
			return ensure(InvoiceBatchItem, value) as T;
		case 'lawpay':
			return ensure(Lawpay, value) as T;
		case 'lead':
			return ensure(Lead, value) as T;
		case 'lookup':
			return ensure(Lookup, value) as T;
		case 'matterStage':
			return ensure(MatterStage, value) as T;
		case 'milestone':
			return ensure(Milestone, value) as T;
		case 'option':
			return ensure(Option, value) as T;
		case 'participant':
			return ensure(Participant, value) as T;
		case 'privilege':
			return ensure(Privilege, value) as T;
		case 'question':
			return ensure(Question, value) as T;
		case 'redFlagType':
			return ensure(RedFlagType, value) as T;
		case 'redFlag':
			return ensure(RedFlag, value) as T;
		case 'resource':
			return ensure(Resource, value) as T;
		case 'referral':
			return ensure(Referral, value) as T;
		case 'role':
			return ensure(Role, value) as T;
		case 'task':
			return ensure(Task, value) as T;
		case 'templateTask':
			return ensure(TemplateTask, value) as T;
		case 'timeOff':
			return ensure(TimeOff, value) as T;
		case 'transaction':
			return ensure(Transaction, value) as T;
		case 'user':
			return ensure(User, value) as T;
		default:
			throw new Error('Unknown entity: ' + entity);
	}
}

export {initialState, cast};